import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import {MatSelect} from '@angular/material/select';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
  standalone: false,
    selector: 'mat-select-search',
    templateUrl: 'mat-select-search.component.html',
    styleUrls: ['mat-select-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MatSelectSearchComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('searchSelectInput', {read: ElementRef, static: true})
    searchSelectInput!: ElementRef<HTMLInputElement>;

    @Input()
    get filter(): string {
        return this._filter;
    }

    set filter(value: string) {
        this._filter = value || '';
        this.filterChange.emit(this._filter);
    }

    @Output() filterChange = new EventEmitter<string>();

    @Input() panelClass: string | null = null;

    private _filter = '';
    private readonly _onDestroy = new Subject<void>();

    constructor(@Inject(MatSelect) public matSelect: MatSelect,
                private cdr: ChangeDetectorRef) {
    }

    ngOnInit() {
        const searchPanelClass = 'mat-select-search-panel';
        const overlayClass = 'cdk-overlay-pane-select-search';

        if (this.matSelect.panelClass) {
            if (Array.isArray(this.matSelect.panelClass)) {
                this.matSelect.panelClass.push(searchPanelClass, overlayClass);
            } else if (typeof this.matSelect.panelClass === 'string') {
                this.matSelect.panelClass = [this.matSelect.panelClass, searchPanelClass, overlayClass];
            } else if (typeof this.matSelect.panelClass === 'object') {
                (this.matSelect.panelClass as Record<string, boolean>)[searchPanelClass] = true;
                (this.matSelect.panelClass as Record<string, boolean>)[overlayClass] = true;
            }
        } else {
            this.matSelect.panelClass = [searchPanelClass, overlayClass];
        }

        if (this.panelClass) {
            const extra = this.panelClass;
            if (Array.isArray(this.matSelect.panelClass)) {
                this.matSelect.panelClass.push(extra);
            }
        }

        this.matSelect.openedChange
            .pipe(takeUntil(this._onDestroy))
            .subscribe(opened => {
                if (opened) {
                    setTimeout(() => this.searchSelectInput?.nativeElement?.focus());
                } else {
                    this.reset();
                }
            });

        this.filterChange
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => this.cdr.detectChanges());
    }

    ngAfterViewInit() {
        // no-op
    }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    onKeydown(event: KeyboardEvent) {
        if (event.code === 'Space' || event.key === ' ') {
            event.stopPropagation();
        }
    }

    onInputChange(value: string) {
        if (value !== this._filter) {
            this.filter = value;
        }
    }

    private reset() {
        if (this.searchSelectInput) {
            this.searchSelectInput.nativeElement.value = '';
        }
        this.filter = '';
    }
}
